import client from './client';

export const kpiBoard = (month) => client.get('/kpi', { params: month ? { month } : {} }).then((r) => r.data);
export const kpiMonths = () => client.get('/kpi/months').then((r) => r.data);
export const kpiDetail = (userId) => client.get(`/kpi/${userId}`).then((r) => r.data);
export const kpiExpected = (userId, batch) =>
  client.get(`/kpi/${userId}/expected`, { params: { batch } }).then((r) => r.data);
export const kpiSnapshot = () => client.post('/kpi/snapshot').then((r) => r.data);
export const kpiHistory = (userId) => client.get(`/kpi/${userId}/history`).then((r) => r.data);
// year: xem biểu đồ theo NĂM (T1–T12). Bỏ trống = năm hiện tại.
export const revenueMonthly = (year) =>
  client.get('/kpi/revenue-monthly', { params: year ? { year } : {} }).then((r) => r.data);
